import styled, { css } from "styled-components"
import { em } from "polished"

const paragraphStyles = css`
  font-size: ${em(18)};
  word-break: break-word;

  @media ${({ theme }) => theme.mq.mediumDown} {
    font-size: ${em(16)};
  }
`

const paragraphSmallStyles = css`
  font-size: ${em(16)};
  word-break: break-word;

  @media ${({ theme }) => theme.mq.mediumDown} {
    font-size: ${em(14)};
  }
`

const paragraphXSmallStyles = css`
  font-size: ${em(14)};
  word-break: break-word;

  @media ${({ theme }) => theme.mq.mediumDown} {
    font-size: ${em(13)};
  }
`

const paragraphLargeStyles = css`
  font-size: ${em(20)};
  word-break: break-word;

  @media ${({ theme }) => theme.mq.mediumDown} {
    font-size: ${em(18)};
  }
`

const Paragraph = styled.p`
  ${paragraphStyles}
`

const ParagraphSmall = styled.p`
  ${paragraphSmallStyles}
`

const ParagraphXSmall = styled.p`
  ${paragraphXSmallStyles}
`

const ParagraphLarge = styled.p`
  ${paragraphLargeStyles}
`

export {
  Paragraph,
  ParagraphSmall,
  ParagraphXSmall,
  ParagraphLarge,
  paragraphStyles,
  paragraphSmallStyles,
  paragraphXSmallStyles,
  paragraphLargeStyles,
}
